import { Flowmodoro } from "../../../types/types";

export const getYearFlowmodoros = (records: Flowmodoro[], fullYear: number) => {
   return records.filter(record => fullYear  === new Date(record.date).getFullYear()) 
}